import React, { useState, useEffect } from 'react';

const DynamicRender = (props) => {
    useEffect(() => {
        if (window.hasOwnProperty(`${props.view}s_render`)) {
            window[`${props.view}s_render`]();
        }
        return () => {
            if (window.hasOwnProperty(`${props.view}s_unMount`)) {
                window[`${props.view}s_unMount`]();
            }
        };
    }, []);

    return (
        <div className="secondLayout">
            <div id={"infinity-" + props.view + "-app"}></div>
        </div>
    );
}

const ExternalAppContainer = (props) => {
    const { view } = props;
    const [currentView, setCurrentView] = useState('');
    const [show, setShow] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setCurrentView(view)
            setShow(true)
        }, 100);
        setShow(false)
    }, [view]);

    return (
        <>
            {show ? <DynamicRender view={currentView} /> : ""}
        </>
    );
}
export default ExternalAppContainer;